<h3>Template</h3>

<form [formGroup]="formFiles">

  <section fxLayout="row">
    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label i18n>Upload new dxf template</mat-label>
      <ngx-mat-file-input formControlName="template" #dxfTemplate accept=".dxf">
      </ngx-mat-file-input>
      <button mat-icon-button matSuffix *ngIf="!dxfTemplate.empty; else dxfTemplateAttachment"
        (click)="dxfTemplate.clear($event)">
        <mat-icon>clear</mat-icon>
      </button>
      <ng-template #dxfTemplateAttachment>
        <button mat-icon-button matSuffix>
          <mat-icon>insert_drive_file</mat-icon>
        </button>
      </ng-template>
    </mat-form-field>
  </section>

  <section fxLayout="row" fxLayoutGap="16px">

    <app-logo *ngIf="logo" [blob]="logo"></app-logo>

    <div fxFlex fxLayout="column" fxLayoutGap="8px">
      <mat-form-field appearance="outline">
        <mat-label i18n>Upload new logo</mat-label>
        <ngx-mat-file-input formControlName="logo" #logoInput accept="image/png,image/jpeg">
        </ngx-mat-file-input>
        <button mat-icon-button matSuffix *ngIf="!logoInput.empty; else logoAttachment"
          (click)="logoInput.clear($event)">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-hint i18n>Only png or jpg</mat-hint>
        <ng-template #logoAttachment>
          <button mat-icon-button matSuffix>
            <mat-icon>insert_drive_file</mat-icon>
          </button>
        </ng-template>

      </mat-form-field>

      <div *ngIf="logo">
        <button mat-stroked-button color="warn" (click)="removeLogo()">
          <mat-icon>delete</mat-icon>
          <span i18n>REMOVE</span>
        </button>
      </div>
    </div>

  </section>
</form>

<form *ngIf="form else loading" [formGroup]="form">
  <div fxLayout="row wrap">
    <mat-form-field fxFlex="100" appearance="outline">
      <mat-label i18n>Parameters definition responsible</mat-label>
      <input matInput formControlName="dxf_params_responsible">
    </mat-form-field>

    <mat-form-field fxFlex="100" appearance="outline">
      <mat-label i18n>Technical responsible</mat-label>
      <input matInput formControlName="dxf_technical_responsible">
    </mat-form-field>

    <mat-form-field fxFlex="100" appearance="outline">
      <mat-label i18n>Approver</mat-label>
      <input matInput formControlName="dxf_approver">
    </mat-form-field>
  </div>
</form>

<ng-template #loading>
  <app-loading></app-loading>
</ng-template>

<mat-action-row>
  <button mat-button matDialogClose i18n>CLOSE</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="this.form?.invalid" i18n>SAVE</button>
</mat-action-row>
